<template>
  <!--   <svg width="32" height="32" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(.75 .56)" fill="none" fill-rule="evenodd">
      <ellipse fill="#92D05F" cx="7.846" cy="7.73" rx="7.846" ry="7.73" />
      <ellipse fill="#333743" cx="4.474" cy="5.084" rx="1.09" ry="1.074" />
      <ellipse fill="#333743" cx="11.562" cy="5.084" rx="1.09" ry="1.074" />
      <path
        d="M5.02 9.103c2.139 3.512 4.163 3.512 6.073 0 .45-.828-.699.544-1.616 1.065-.918.523-2.116.256-2.448.122a8.065 8.065 0 0 1-2.01-1.187z"
        fill="#333743" />
    </g>
  </svg> -->
  <svg width="40" height="40" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12" stroke="#FFF" stroke-width="3"
        fill="#6EBF43" />
      <path
        d="M11.91 13.946a.204.204 0 0 1-.25.021c-1.897-1.203-3.948-.59-4.393-.49a.203.203 0 0 1-.043.005.226.226 0 0 1-.204-.149c-.057-.134.015-.26.117-.353.326-.304 2.452-2.353 4.802.574a.293.293 0 0 1-.03.392M16.09 13.946c.073.063.17.072.25.021 1.897-1.203 3.948-.59 4.393-.49a.203.203 0 0 0 .043.005.226.226 0 0 0 .204-.149c.057-.134-.015-.26-.117-.353-.326-.304-2.452-2.353-4.802.574a.293.293 0 0 0 .03.392M10 18s.65 3 4 3c3.322 0 4-3 4-3h-8z"
        fill="#000" />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmoticonFace4'
})
</script>
